/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColorObject } from './index';

/**
 * Didn't defined this as a ColorObject because contrastTextHex is not a hex value and contrastTextRGB will
 * change depending on theme, but defined all other attributes.
 */
export const transparent = {
  id: 'transparent',
  name: 'Transparent',
  group: 'neutral',
  hex: 'transparent',
  rgba: [0, 0, 0, 0],
  contrastTextHex: 'palette.text.primary',
};

export const highlightColors: ReadonlyArray<ColorObject> = [
  {
    id: 'highlight-green-200',
    hex: '#D9FAAF',
    rgb: [217, 250, 175],
    name: 'highlight-green-200',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-green-300',
    hex: '#BAF285',
    rgb: [186, 242, 133],
    name: 'highlight-green-300',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-green-400',
    hex: '#9CE664',
    rgb: [156, 230, 100],
    name: 'highlight-green-400',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-green-600',
    hex: '#53B826',
    rgb: [83, 184, 38],
    name: 'highlight-green-600',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-blue-200',
    hex: '#B8DAFF',
    rgb: [184, 218, 255],
    name: 'highlight-blue-200',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-blue-300',
    hex: '#95C3FF',
    rgb: [149, 195, 255],
    name: 'highlight-blue-300',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-blue-400',
    hex: '#7AAFFF',
    rgb: [122, 175, 255],
    name: 'highlight-blue-400',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-blue-600',
    hex: '#396EDB',
    rgb: [57, 110, 219],
    name: 'highlight-blue-600',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-yellow-200',
    hex: '#FFF2B0',
    rgb: [255, 242, 176],
    name: 'highlight-yellow-200',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-yellow-300',
    hex: '#FFE988',
    rgb: [255, 233, 136],
    name: 'highlight-yellow-300',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-yellow-400',
    hex: '#FFE06B',
    rgb: [255, 224, 107],
    name: 'highlight-yellow-400',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-yellow-600',
    hex: '#DBAD2A',
    rgb: [219, 173, 42],
    name: 'highlight-yellow-600',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-red-200',
    hex: '#FFD0AB',
    rgb: [255, 208, 171],
    name: 'highlight-red-200',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: 'highlight-red-300',
    hex: '#FFB081',
    rgb: [255, 176, 129],
    name: 'highlight-red-300',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-red-400',
    hex: '#FF9161',
    rgb: [255, 145, 97],
    name: 'highlight-red-400',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: 'highlight-red-600',
    hex: '#DB3E20',
    rgb: [219, 62, 32],
    name: 'highlight-red-600',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
];
